import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from './components/Login/AuthContext';
import { Analytics } from '@vercel/analytics/react';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import App from './App'
const queryClient = new QueryClient()


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
    <Analytics beforeSend={event => /^\/(auth(?:\/|$)|reset-password(?:\/|$))/.test(window.location.pathname) ? null : event} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
